
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { DateTimeDisplay } from 'core/Display';
import { Button } from '@material-ui/core';

import TableListSort from 'core/TableListSort';
import DeleteDialog from 'core/DeleteDialog';
import Colors from "ui/Colors";

const StyledTableHead = styled(TableHead)`
`;

const StyledCounter = styled.span`
  margin-left: 5px;
  color: ${Colors.Gray1};
`;

const CellValue = styled.div`
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
`;


export class ScheduleListTable extends Component {

  disableClickEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const { context, items, loading, onDetail, onDelete } = this.props;
    const { counts } = context.response;

    return (
      <React.Fragment>
        <StyledTableHead>
          <TableRow>
            <TableCell component="th" scope="row">ТС <StyledCounter>({counts.tractor_units})</StyledCounter></TableCell>
            <TableCell component="th" scope="row">Водитель <StyledCounter>({counts.drivers})</StyledCounter></TableCell>
            <TableCell component="th" scope="row">Полуприцеп <StyledCounter>({counts.semi_trailers})</StyledCounter></TableCell>
            <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap', width: '120px'}}>
              <TableListSort label={'Дата начала'} name={'date_start'} />
            </TableCell>
            <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap', width: '120px'}}>
              <TableListSort label={'Дата окончания'} name={'date_end'} />
            </TableCell>
            <TableCell />
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={6}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {items.map(item => {
            return (
              <TableRow
                key={item.id}
                hover={true}
                className={'pointer'}
                style={{backgroundColor: item.status === 'NOT_WORKING' ? '#eb57570d' : ''}}
                onClick={(event) => onDetail(item)}
              >
                <TableCell>
                  <CellValue>
                    {item.tractor_unit ? item.tractor_unit.label : '-'}
                    {item.tractor_unit && (
                      <span onClick={(e) => this.disableClickEvent(e)}>
                        <IconButton
                          size={'small'}
                          onClick={() => context.setFilterValue('tractor_unit', item.tractor_unit.id)}
                        >
                          <SearchIcon />
                        </IconButton>
                      </span>
                    )}
                  </CellValue>
                </TableCell>
                <TableCell>
                  <CellValue>
                    {item.driver ? item.driver.short_name : '-'}
                    {item.driver && (
                      <span onClick={(e) => this.disableClickEvent(e)}>
                        <IconButton
                          size={'small'}
                          onClick={() => context.setFilterValue('driver', item.driver.id)}
                        >
                          <SearchIcon />
                        </IconButton>
                      </span>
                    )}
                  </CellValue>
                </TableCell>
                <TableCell>
                  <CellValue>
                    {item.semi_trailer ? item.semi_trailer.label : '-'}
                    {item.semi_trailer && (
                      <span onClick={(e) => this.disableClickEvent(e)}>
                        <IconButton
                          size={'small'}
                          onClick={() => context.setFilterValue('semi_trailer', item.semi_trailer.id)}
                        >
                          <SearchIcon />
                        </IconButton>
                      </span>
                    )}
                  </CellValue>
                </TableCell>
                <TableCell><DateTimeDisplay value={item.date_start} /></TableCell>
                <TableCell>
                  {item.is_unlimited ? 'Бессрочная' : <DateTimeDisplay value={item.date_end} /> }
                </TableCell>
                <TableCell className={'disable-click'} onClick={(e) => this.disableClickEvent(e)}>
                  {!item.order && (
                    <CellValue>
                      <Button
                        component={Link}
                        to={`/schedule/add/${item.id}`}
                        size={'small'}
                        variant={'outlined'}
                      >
                        Продлить
                      </Button>
                      {item.can_delete && (
                        <DeleteDialog
                          item={item}
                          itemLabel={'данную связку'}
                          onDelete={() => onDelete(item)}
                          buttonRenderer={
                            (openDialog) => (
                              <Button
                                size={'small'}
                                variant={'outlined'}
                                onClick={(e) => openDialog(e)}
                              >
                                Удалить
                              </Button>
                            )
                          }
                        />
                      )}
                    </CellValue>
                  )}
                </TableCell>
              </TableRow>
            )
          })}
          {(!loading && items.length === 0) && (
            <TableRow>
              <TableCell colSpan={6}>Ничего не найдено</TableCell>
            </TableRow>
          )}
        </TableBody>
      </React.Fragment>
    )
  }
}
